import { z } from 'zod';
export const ProductIdSchema = z.string().refine((value) => /^[A-Z]{3}\d{3}$/g.test(value));
export type ProductId = z.infer<typeof ProductIdSchema>;
